import { NgModule } from '@angular/core';
import { AngularMaterialModule } from '../../../material.module';
import { OptionalPlaceholderPipe } from '@lib/pipes';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SpinnerComponent } from '@lib/components/spinner/spinner.component';
import { TableButtonComponent, TableComponent, TableDateFilterComponent, TableFilterComponent, TableLazyloadComponent } from '@lib/modules/table/components';
import { TableColumnDirective, TableFilterDirective, TableIconDirective, TypedMatCellDefDirective } from '@lib/modules/table/directives';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableSearchComponent } from './components/table-search/table-search.component';

@NgModule({
    imports: [AngularMaterialModule, DragDropModule, OptionalPlaceholderPipe, SpinnerComponent, FormsModule, ReactiveFormsModule],
    declarations: [
        TableComponent,
        TableFilterComponent,
        TableButtonComponent,
        TableLazyloadComponent,
        TableColumnDirective,
        TableFilterDirective,
        TypedMatCellDefDirective,
        TableIconDirective,
        TableDateFilterComponent,
        TableSearchComponent,
        TableSearchComponent,
    ],
    exports: [TableComponent, TableFilterComponent, TableButtonComponent, TableLazyloadComponent, TableColumnDirective, TableFilterDirective, TypedMatCellDefDirective, TableIconDirective, TableDateFilterComponent, TableSearchComponent],
})
export class TableModule {}
